export enum StudyFormValidationType {
  SAVING = 'SAVING',
  SUBMISSION = 'SUBMISSION'
}
